import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App as AntdApp } from "antd";
import App from "./App";
import { CartProvider } from "./contextApi/CartProvider";
import { ImageVersionProvider } from "./contextApi/ImageVersionContext";
import { HelmetProvider } from "react-helmet-async";

ReactDOM.createRoot(document.getElementById("root")).render(

    <BrowserRouter >
    <AntdApp>
    <ImageVersionProvider>
    <CartProvider>
      <HelmetProvider>
      <App />
      </HelmetProvider>
      </CartProvider>
    </ImageVersionProvider>
    </AntdApp>
    </BrowserRouter>
  
);
